// import simpleParallax from '../vendors/simpleParallax/dist/simpleParallax';
window.modules = {};
// window.$ = window.jQuery = require('jquery');
// require('./bootstrap');
window.Swiper = require('swiper/js/swiper.min');
window.simpleParallax = require('simple-parallax-js');
window.simpleLightbox = require('simplelightbox/dist/simple-lightbox');
// window.WOW = require('../vendors/wowjs/dist/wow');
window.WOW = require('../vendors/wowjs/dist/wow').WOW;
require('../vendors/smoothscroll/smoothscroll');

require('./javascript');
// require('./apartments');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js